import { styled } from "@mui/material"

// PrimaryTile's look on a native <button> — PrimaryTile is a styled Box and can't type button props.
export const TileButton = styled("button")(({ theme }) => ({
  background: theme.palette.common.white,
  borderRadius: "8px",
  border: `1px solid ${theme.palette.mockup.primary95}`,
}))
